import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PlantGroupElement } from '../models/O3AdministrationModels/plant-model';
import { Plantbygroup } from '../models/plantbygroup';
import { ProductLine } from '../models/ProductLine';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  get O3CoreApiUrl(): string { return Constants.CORE_API_BASE_URL; }
  constructor(private http: HttpClient) { }

  getGroupData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'common/GetGroup', data);
  }
  getTreeModal(data: any): Observable<PlantGroupElement[]> {
    return this.http.post<PlantGroupElement[]>(this.O3CoreApiUrl + 'common/GetTreeModal', data);
  }
  // getGroups(): Observable<any[]> {
  //   return this.http.get<any[]>(this.kpiUrl + 'groups');
  // }

  // getPlants(groupId: any): Observable<Plantbygroup[]> {
  //   return this.http.post<Plantbygroup[]>(this.kpiUrl + 'plantsbygroup', groupId);
  // }
  getUnitDataByMultipleLines(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Dashboard/GetUnitListByMultipleLine', data);
  }
  getmasterline(data: any): Observable<ProductLine[]> {
    return this.http.post<ProductLine[]>(this.O3CoreApiUrl + 'Machine_Core/GetMasterLines', data);
  }
  async getMachineByLine(data: any): Promise<any> {
    return await this.http.post<any[]>(this.O3CoreApiUrl + 'Machine_Core/GetUnitsByLine', data).toPromise();
  }
  getProductsByUnit(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'NCR/Productsbyunit', data);
  }

  getPeopleMasterData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'PeopleMaster_Core/GetEmployeeMasterInfoData', data);
  }

  getAllEmployess(): Observable<any>{
    return this.http.get<any>(this.O3CoreApiUrl + 'Employee/getAllEmployees');
  }

  getPeopleMasterEmpData(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'PeopleMaster/GetEmployeeMasterInfo', data);
  }
  getLineList(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Common/GetLineByPlantCode', data);
    //return this.http.post<any[]>(this.O3CoreApiUrl + 'Dashboard/GetLineList', data);
  }

  getUnitList(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Common/GetUnitsByLineId', data);
    //return this.http.post<any[]>(this.O3CoreApiUrl + 'Dashboard/GetUnitList', data);
  }

  productionOutputByBarcode(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'BarcodePrint/ProductionOutputByBarcode', data);
  }

  GetFullNameByUserId(data): Observable<any> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Common/GetFullNameByUserId', data);
  }

  getDivisionPlantwise(data: any): Observable<PlantGroupElement[]> {
    return this.http.post<any>(this.O3CoreApiUrl + 'DivisionModule/GetDivisionPlantwise', data);
  }
  GetUnitByPlant(data: any): Observable<PlantGroupElement[]> {
    return this.http.post<any>(this.O3CoreApiUrl + 'common/GetUnitByPlant', data);
  }

  SaveDialogData(data: any): Observable<PlantGroupElement[]> {
    return this.http.post<any>(this.O3CoreApiUrl + 'Planner/AddProductionPlanByBatch', data);
  }

  getLotDetails(data:any): Observable<any> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Common/GetProductionLotDetails',data);
  }
 
  GetProductionWasteAnalysis(data): Observable<any> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Common/GetProductionWasteAnalysis',data);
  }

  GetWasteDetails(data): Observable<any> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Common/GetWasteDetails',data);
  }

  GetParametersDetailsByProduction(data): Observable<any> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Common/GetParametersDetailsByProduction',data);
  }

  GetProductionWasteAnalysisByProduct(data): Observable<any> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Common/GetProductionWasteAnalysisByProduct',data);
  }

  getProductsMasterByPlantId(data: any): Observable<any> {
    return this.http.post<any>(this.O3CoreApiUrl + 'CustomerUser/getProductsMasterByPlantId', data);
  }

  resetUserPassword(payload: any):Observable<any>{
    return this.http.post<any>(this.O3CoreApiUrl + 'Auth/resetUserPassword', payload);
  }

  checkUserExistence(payload: any):Observable<any>{
    return this.http.post<any>(this.O3CoreApiUrl + 'Auth/FindUserByEmailOrUserName', payload);
  }

  sendForgotPasswordEmail(payload: any):Observable<any>{
    return this.http.post<any>(this.O3CoreApiUrl + 'Auth/SendForgotPasswordEmail', payload);
  }
  sendForgotPasswordWhatsapp(payload: any):Observable<any>{
    return this.http.post<any>(this.O3CoreApiUrl + 'Auth/SendForgotPasswordWhatsapp', payload);
  }

  ForgotPasswordWhatsApp(payload: any):Observable<any>{
    return this.http.post<any>(this.O3CoreApiUrl + 'Users/ForgotPasswordWhatsApp', payload);
  }
  saveFavorite(data): Observable<any> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'DynamicDashboard/SaveFavorite',data);
  }

  getFavoriteList(): Observable<any> {
    return this.http.get<any[]>(this.O3CoreApiUrl + 'DynamicDashboard/GetFavoriteList');
  }
}
